import { render, staticRenderFns } from "./DisplayStudents.vue?vue&type=template&id=040558da&scoped=true&"
import script from "./DisplayStudents.vue?vue&type=script&lang=js&"
export * from "./DisplayStudents.vue?vue&type=script&lang=js&"
import style0 from "./DisplayStudents.vue?vue&type=style&index=0&id=040558da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040558da",
  null
  
)

export default component.exports